import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TemplateDocCompatibleTagsEditing from './templatedoccompatibletagsediting';

export default class TemplateDocCompatibleTags extends Plugin {
  static get requires() {
    return [ TemplateDocCompatibleTagsEditing ];
  }

  static get pluginName() {
    return 'TemplateDocCompatibleTags';
  }
}
